<template>
  <div class="manage-product">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="left-section">
        <button class="back-btn" @click="goBack">
          <span>←</span>
        </button>
      </div>
      <div class="right-section">
        <button class="add-item-btn" @click="openAddProductModal">
          添加货物
        </button>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <p>加载中...</p>
    </div>

    <!-- 商品列表 -->
    <div v-else class="product-list">
      <div 
        v-for="product in products" 
        :key="product.id" 
        class="product-card"
      >
        <div class="product-info">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-details">
            <div class="detail-item">
              <span class="label">单位:</span>
              <span class="value">{{ product.unit }}</span>
            </div>
          </div>
        </div>
        
        <div class="product-actions">
          <div class="action-links">
            <span class="action-link" @click="viewPriceList(product)">价钱表</span>
            <span class="action-link" @click="modifyProduct(product)">修改</span>
            <span class="action-link" @click="deleteProduct(product)">删除</span>
          </div>
          <div class="toggle-switch">
            <input 
              type="checkbox" 
              :id="'toggle-' + product.id"
              v-model="product.isActive"
              @change="toggleProductStatus(product)"
            >
            <label :for="'toggle-' + product.id"></label>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加商品模态框 -->
    <div v-if="addProductModalVisible" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <h3>添加商品</h3>
          <button class="close-btn" @click="closeAddProductModal">×</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addProduct">
            <div class="form-group">
              <label>产品名称</label>
              <input 
                type="text" 
                v-model="newProduct.productName" 
                required
                placeholder="请输入产品名称"
              >
            </div>
            <div class="form-group">
              <label>产品单位</label>
              <input 
                type="text" 
                v-model="newProduct.productUnit" 
                required
                placeholder="请输入产品单位"
              >
            </div>
            <div class="form-group">
              <label>现库存</label>
              <input 
                type="number" 
                v-model.number="newProduct.totalStocks" 
                required
                placeholder="请输入现库存"
              >
            </div>
            <div class="form-actions">
              <button type="submit" class="submit-btn">提交</button>
              <button type="button" @click="closeAddProductModal" class="cancel-btn">取消</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 价格表弹窗 -->
    <div v-if="priceListVisible" class="price-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ currentProductName }} - 价格表</h3>
          <button class="close-btn" @click="closePriceList">×</button>
        </div>
        <div class="modal-body">
          <table class="price-table">
            <thead>
              <tr>
                <th>价格ID</th>
                <th>价格</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="priceItem in priceList" :key="priceItem.priceId">
                <td>{{ priceItem.priceId }}</td>
                <td>{{ priceItem.price }}</td>
                <td>
                  <button class="delete-btn" @click="deletePrice(priceItem.priceId)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button class="add-price-btn" @click="showAddPriceInput = true">添加价格</button>
          
          <div v-if="showAddPriceInput" class="add-price-input">
            <input 
              type="number" 
              v-model="newPrice" 
              placeholder="输入新价格" 
              class="price-input"
            >
            <div class="add-price-actions">
              <button class="confirm-add-btn" @click="addPrice">确认</button>
              <button class="cancel-add-btn" @click="showAddPriceInput = false">取消</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  name: 'ManageProduct',
  data() {
    return {
      products: [],
      loading: true,
      error: null,
      // 价格表相关数据
      priceListVisible: false,
      priceList: [],
      currentProductId: null,
      currentProductName: '',
      showAddPriceInput: false,
      newPrice: '',
      // 添加商品相关数据
      addProductModalVisible: false,
      newProduct: {
        categoryId: null,
        productName: '',
        productUnit: '',
        totalStocks: 0
      }
    }
  },
  created() {
    this.fetchProducts();
    // 从路由参数获取categoryId
    this.newProduct.categoryId = this.$route.query.itemId || '10';
  },
  methods: {
    async fetchProducts() {
      try {
        // 从路由参数获取categoryId，默认为10
        const categoryId = this.$route.query.itemId || '10';
        
        const options = {
          method: 'GET',
          url: '/admin/manage/product/getProduct',
          params: { categoryId }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          // 转换后端数据格式以适配前端
          this.products = response.data.data.map(item => ({
            id: item.productId,
            name: item.productName,
            unit: item.productUnit,
            currentStock: item.totalStocks,
            loss: item.loss,
            isActive: item.status === 1,
            createTime: item.createTime
          }));
        } else {
          this.error = response.data.message || '获取商品列表失败';
        }
      } catch (error) {
        this.error = error.message || '网络错误，请稍后重试';
        console.error('获取商品列表错误:', error);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      // 返回上一页
      this.$router.go(-1)
    },
    openAddProductModal() {
      // 重置表单
      this.newProduct = {
        categoryId: this.$route.query.itemId || '10',
        productName: '',
        productUnit: '',
        totalStocks: 0
      };
      this.addProductModalVisible = true;
    },
    closeAddProductModal() {
      this.addProductModalVisible = false;
    },
    async addProduct() {
      // 验证表单
      if (!this.newProduct.productName || !this.newProduct.productUnit || this.newProduct.totalStocks <= 0) {
        alert('请填写完整的产品信息');
        return;
      }
      
      try {
        const options = {
          method: 'POST',
          url: '/admin/manage/product/addProduct',
          headers: {'content-type': 'application/json'},
          data: this.newProduct
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          alert('产品添加成功');
          this.closeAddProductModal();
          await this.fetchProducts(); // 刷新产品列表
        } else {
          alert('添加失败: ' + response.data.message);
        }
      } catch (error) {
        alert('网络错误，请稍后重试');
        console.error('添加产品错误:', error);
      }
    },
    async viewPriceList(product) {
      // 查看价格表逻辑
      this.currentProductId = product.id;
      this.currentProductName = product.name;
      this.priceListVisible = true;
      await this.fetchPriceList();
    },
    closePriceList() {
      this.priceListVisible = false;
      this.priceList = [];
      this.currentProductId = null;
      this.currentProductName = '';
      this.showAddPriceInput = false;
      this.newPrice = '';
    },
    modifyProduct(product) {
      // 修改商品逻辑
      console.log('修改商品:', product.name)
    },
    async deleteProduct(product) {
      if (confirm(`确定要删除商品 "${product.name}" 吗？`)) {
        try {
          // 发送删除商品请求
          const options = {
            method: 'DELETE',
            url: '/admin/manage/product/deleteProduct',
            params: { productId: product.id }
          };
          
          const response = await adminrequest.request(options);
          
          if (response.data.code === 200) {
            // 删除成功，刷新商品列表
            await this.fetchProducts();
            alert('商品删除成功');
          } else {
            alert('删除失败: ' + response.data.message);
          }
        } catch (error) {
          alert('网络错误，请稍后重试');
          console.error('删除商品错误:', error);
        }
      }
    },
    toggleProductStatus(product) {
      // 切换商品状态逻辑
      console.log(`${product.name} 状态切换为:`, product.isActive ? '启用' : '禁用');
      
      // 这里应该调用后端API更新商品状态
      console.log('调用API更新商品状态:', product.id, product.isActive ? 1 : 0);
    },
    async deletePrice(priceId) {
      if (confirm('确定要删除这个价格吗？')) {
        try {
          // 发送删除价格请求
          const options = {
            method: 'DELETE',
            url: '/admin/manage/product/deletePrice',
            params: { priceId }
          };
          
          const response = await adminrequest.request(options);
          
          if (response.data.code === 200) {
            // 删除成功，刷新价格列表
            await this.fetchPriceList();
            alert('价格删除成功');
          } else {
            alert('删除失败: ' + response.data.message);
          }
        } catch (error) {
          alert('网络错误，请稍后重试');
          console.error('删除价格错误:', error);
        }
      }
    },
    async addPrice() {
      if (!this.newPrice || isNaN(Number(this.newPrice))) {
        alert('请输入有效的价格');
        return;
      }
      
      // 创建FormData对象
      const form = new FormData();
      form.append("productId", this.currentProductId);
      form.append("price", this.newPrice);
      
      try {
        const options = {
          method: 'POST',
          url: '/admin/manage/product/addPrice',
          data: form,
          // 注意：FormData提交时不需要设置Content-Type，浏览器会自动处理
          headers: {
            'Content-Type': undefined
          }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          // 添加成功，刷新价格列表
          await this.fetchPriceList();
          this.showAddPriceInput = false;
          this.newPrice = '';
          alert('价格添加成功');
        } else {
          alert('添加失败: ' + response.data.message);
        }
      } catch (error) {
        alert('网络错误，请稍后重试');
        console.error('添加价格错误:', error);
      }
    },
    // 添加一个获取价格列表的方法，便于复用
    async fetchPriceList() {
      try {
        const options = {
          method: 'GET',
          url: '/admin/export/getPrice',
          params: { productId: this.currentProductId }
        };
        
        const response = await adminrequest.request(options);
        
        if (response.data.code === 200) {
          this.priceList = response.data.data;
        } else {
          alert('获取价格列表失败: ' + response.data.message);
        }
      } catch (error) {
        alert('网络错误，请稍后重试');
        console.error('获取价格列表错误:', error);
      }
    }
  }
}
</script>

<style scoped>
/* 保持原有样式不变 */
.manage-product {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.back-btn {
  background: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background-color: #f0f0f0;
}

.add-item-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.add-item-btn:hover {
  background-color: #0056b3;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.product-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.product-card {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.product-info {
  flex: 1;
}

.product-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.product-details {
  display: flex;
  gap: 20px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

.label {
  color: #666;
  font-size: 14px;
}

.value {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.product-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.action-links {
  display: flex;
  gap: 15px;
}

.action-link {
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.action-link:hover {
  color: #0056b3;
}

/* 开关样式 */
.toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch label {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-switch label:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.toggle-switch input:checked + label {
  background-color: #28a745;
}

.toggle-switch input:checked + label:before {
  transform: translateX(26px);
}

/* 价格表弹窗样式 */
.price-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 600px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  transition: color 0.3s ease;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.price-table {
  width: 100%;
  border-collapse: collapse;
}

.price-table th, .price-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.price-table th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.delete-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s ease;
}

.delete-btn:hover {
  background-color: #c82333;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.add-price-btn {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
  align-self: flex-start;
}

.add-price-btn:hover {
  background-color: #218838;
}

.add-price-input {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.price-input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.add-price-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.confirm-add-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.confirm-add-btn:hover {
  background-color: #0069d9;
}

.cancel-add-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.cancel-add-btn:hover {
  background-color: #5a6268;
}

/* 添加商品模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.submit-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.submit-btn:hover {
  background-color: #0069d9;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background-color: #5a6268;
}
</style>  